if (!customElements.get('shop-the-look-modal')) {
  customElements.define(
    'shop-the-look-modal',
    class ShopTheLookModal extends ModalDialog {
      constructor() {
        super();
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const event = new CustomEvent('modal-dialog:opened', {
          bubbles: true,
          detail: { elementToFocus: this },
        });
        document.dispatchEvent(event);
      }
    }
  );
}
